import { render, staticRenderFns } from "./NotesSelector.vue?vue&type=template&id=d72caeaa"
import script from "./NotesSelector.vue?vue&type=script&lang=js"
export * from "./NotesSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports